import React from "react";
import { cn } from "@/lib/utils";
import { CATEGORIES, type VitrineCategory } from "./data/vitrineItems";

interface VitrineFiltersProps {
  active: VitrineCategory | "all";
  onChange: (cat: VitrineCategory | "all") => void;
  counts: Record<string, number>;
}

const VitrineFilters = ({ active, onChange, counts }: VitrineFiltersProps) => {
  return (
    <div className="flex flex-wrap gap-2">
      {CATEGORIES.map((c) => {
        const isActive = active === c.id;
        const count = c.id === "all" ? counts.all : counts[c.id] || 0;
        if (count === 0 && c.id !== "all") return null;
        return (
          <button
            key={c.id}
            onClick={() => onChange(c.id)}
            className={cn(
              "px-4 py-2 rounded-full text-sm font-semibold border transition-all",
              isActive
                ? "bg-gradient-to-r from-yellow-500 to-amber-500 text-black border-yellow-600 shadow"
                : "bg-card text-foreground border-border hover:border-yellow-500/50 hover:text-yellow-600"
            )}
          >
            {c.label} <span className="opacity-70 ml-1">({count})</span>
          </button>
        );
      })}
    </div>
  );
};

export default VitrineFilters;
